let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3p9Tp")).then(() => parcelRequire('34b5q'));